import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]

  connect() {
    this.timeout = setTimeout(() => {
      this.dismiss()
    }, 5000)
  }

  dismiss() {
    this.containerTarget.classList.add("opacity-0", "transition", "duration-500")

    setTimeout(() => {
      this.containerTarget.remove()
    }, 300)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
